// src/pages/Vouchers/GeneralReceiptForm.jsx
import React from 'react';
import VoucherForm, { VOUCHER_CONFIGS } from './VoucherForm';

export default function GeneralReceiptForm() {
  return <VoucherForm config={VOUCHER_CONFIGS.generalReceipt} />;
}
